<script setup lang="ts">
// MegaHow — "Как это работает": 3 steps (01/02/03), each number on a small cream
// paper tag stuck on a little askew, a heading and a blurb, under a pencil line.
//
// SSG/hydration-safe: purely static. Each step wraps itself in <ScrollReveal>
// (visible in the static HTML; only below-the-fold steps get an entrance).
import ScrollReveal from '@/components/ui/animation/ScrollReveal.vue';

interface Step {
  n: string;
  t: string;
  s: string;
}

const steps: Step[] = [
  { n: '01', t: 'Задай вопрос', s: 'Своими словами, как другу. «Он напишет?» — этого достаточно.' },
  { n: '02', t: 'Кот тянет карты', s: 'Выбери расклад — кот вытянет карты под твою ситуацию.' },
  { n: '03', t: 'Получи разбор', s: 'Тёплый, человеческий ответ. Без эзотерического тумана.' },
];

const TILTS = [-3, 2, -1.5];

// Staggered reveal delays (ms): d1=80, d2=160, d3=240.
const revealDelay = (i: number) => (i + 1) * 80;
</script>

<template>
  <section
    id="how"
    class="scroll-mt-20 pb-16 md:pb-24"
  >
    <div class="site-container">
      <div class="grid grid-cols-1 gap-7 sm:grid-cols-3">
        <ScrollReveal
          v-for="(s, i) in steps"
          :key="i"
          :delay="revealDelay(i)"
          class="how-step relative pt-[22px]"
        >
          <span
            class="how-num paper-tag inline-block px-2.5 py-0.5 font-serif text-[32px] leading-tight"
            :style="{ '--tilt': `${TILTS[i]}deg` }"
          >{{ s.n }}</span>
          <h3 class="type-heading mt-4 text-foreground">{{ s.t }}</h3>
          <p class="mt-2.5 text-[15.5px] leading-[1.55] text-muted-foreground">{{ s.s }}</p>
        </ScrollReveal>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* A pencil line across the top of each step (dashed, like a fold to cut along). */
.how-step::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1.5px dashed color-mix(in srgb, var(--foreground) 22%, transparent);
}
.how-num {
  border-radius: var(--paper-radius-xs);
  transform: rotate(var(--tilt));
  box-shadow: inset 0 1px 0 rgb(255 255 255 / 0.5), 0 4px 8px -3px var(--paper-shade);
}
</style>
